/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { MoneyTransactionTOResponse } from '../models/money-transaction-toresponse';
import { NftWithdrawalForm } from '../models/nft-withdrawal-form';
import { CancelWithdrawForm } from '../models/cancel-withdraw-form';
import { ConfirmWithdrawForm } from '../models/confirm-withdraw-form';
import { WithdrawForm } from '../models/withdraw-form';
import { GetWithdrawUsageToResp } from '../models/get-withdraw-usage-to-resp';

/**
 * Withdrawal Controller
 */
@Injectable({
  providedIn: 'root',
})
class WithdrawalControllerService extends __BaseService {
  static readonly withdrawUsingPOSTPath = '/api/v1/wallet/withdrawal/asset';
  static readonly closeUsingPOST1Path = '/api/v1/wallet/withdrawal/cancel';
  static readonly confirmWithdrawUsingPOSTPath = '/api/v1/wallet/withdrawal/confirmation/confirm';
  static readonly withdrawUsingPOST1Path = '/api/v1/wallet/withdrawal/request';
  static readonly usageUsingGETPath = '/api/v1/wallet/withdrawal/usage';
  static readonly resendWithdrawConfirmationEmailUsingPOSTPath = '/api/v1/wallet/withdrawal/{id}/confirmation/resend';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * withdraw
   * @param form form
   * @return OK
   */
  withdrawUsingPOSTResponse(form: NftWithdrawalForm): __Observable<__StrictHttpResponse<MoneyTransactionTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/wallet/withdrawal/asset`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MoneyTransactionTOResponse>;
      })
    );
  }
  /**
   * withdraw
   * @param form form
   * @return OK
   */
  withdrawUsingPOST(form: NftWithdrawalForm): __Observable<MoneyTransactionTOResponse> {
    return this.withdrawUsingPOSTResponse(form).pipe(
      __map(_r => _r.body as MoneyTransactionTOResponse)
    );
  }

  /**
   * close
   * @param form form
   * @return OK
   */
  closeUsingPOST1Response(form: CancelWithdrawForm): __Observable<__StrictHttpResponse<MoneyTransactionTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/wallet/withdrawal/cancel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MoneyTransactionTOResponse>;
      })
    );
  }
  /**
   * close
   * @param form form
   * @return OK
   */
  closeUsingPOST1(form: CancelWithdrawForm): __Observable<MoneyTransactionTOResponse> {
    return this.closeUsingPOST1Response(form).pipe(
      __map(_r => _r.body as MoneyTransactionTOResponse)
    );
  }

  /**
   * confirmWithdraw
   * @param form form
   * @return OK
   */
  confirmWithdrawUsingPOSTResponse(form: ConfirmWithdrawForm): __Observable<__StrictHttpResponse<MoneyTransactionTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/wallet/withdrawal/confirmation/confirm`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MoneyTransactionTOResponse>;
      })
    );
  }
  /**
   * confirmWithdraw
   * @param form form
   * @return OK
   */
  confirmWithdrawUsingPOST(form: ConfirmWithdrawForm): __Observable<MoneyTransactionTOResponse> {
    return this.confirmWithdrawUsingPOSTResponse(form).pipe(
      __map(_r => _r.body as MoneyTransactionTOResponse)
    );
  }

  /**
   * withdraw
   * @param form form
   * @return OK
   */
  withdrawUsingPOST1Response(form: WithdrawForm): __Observable<__StrictHttpResponse<MoneyTransactionTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/wallet/withdrawal/request`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MoneyTransactionTOResponse>;
      })
    );
  }
  /**
   * withdraw
   * @param form form
   * @return OK
   */
  withdrawUsingPOST1(form: WithdrawForm): __Observable<MoneyTransactionTOResponse> {
    return this.withdrawUsingPOST1Response(form).pipe(
      __map(_r => _r.body as MoneyTransactionTOResponse)
    );
  }

  /**
   * usage
   * @return OK
   */
  usageUsingGETResponse(): __Observable<__StrictHttpResponse<GetWithdrawUsageToResp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/v1/wallet/withdrawal/usage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetWithdrawUsageToResp>;
      })
    );
  }
  /**
   * usage
   * @return OK
   */
  usageUsingGET(): __Observable<GetWithdrawUsageToResp> {
    return this.usageUsingGETResponse().pipe(
      __map(_r => _r.body as GetWithdrawUsageToResp)
    );
  }

  /**
   * resendWithdrawConfirmationEmail
   * @param id id
   * @return OK
   */
  resendWithdrawConfirmationEmailUsingPOSTResponse(id: number): __Observable<__StrictHttpResponse<MoneyTransactionTOResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/v1/wallet/withdrawal/${encodeURIComponent(String(id))}/confirmation/resend`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MoneyTransactionTOResponse>;
      })
    );
  }
  /**
   * resendWithdrawConfirmationEmail
   * @param id id
   * @return OK
   */
  resendWithdrawConfirmationEmailUsingPOST(id: number): __Observable<MoneyTransactionTOResponse> {
    return this.resendWithdrawConfirmationEmailUsingPOSTResponse(id).pipe(
      __map(_r => _r.body as MoneyTransactionTOResponse)
    );
  }
}

module WithdrawalControllerService {
}

export { WithdrawalControllerService }
